// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bi-0";
export var orangeButton = "_bi-1";